/* global SideDrawer */

if (!customElements.get('swatch-request-drawer')) {
  class SwatchRequestDrawer extends SideDrawer {
    constructor() {
      super();
      this.content = this.querySelector('.js-swatch-req-details');
      this.footer = this.querySelector('.drawer__footer');
      this.form = this.querySelector('product-form');
      this.notification = this.querySelector('.js-added-to-cart');
      this.backBtn = this.querySelector('.drawer__back-btn');
      this.openCartDrawerLinks = this.querySelectorAll('.js-open-cart-drawer');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.fetch = null;
      this.fetchedUrls = [];
      this.quickAddButtonMouseEnterHandler = this.handleQuickAddButtonMouseEnter.bind(this);
      this.documentClickHandler = this.handleDocumentClick.bind(this);

      document.addEventListener('click', this.documentClickHandler);

      this.openCartDrawerLinks.forEach((link) => {
        link.addEventListener('click', this.handleOpenCartClick.bind(this));
      });

      if (theme.device.hasHover && theme.mediaMatches.md) {
        document.querySelectorAll('.js-swatch-req-drawer').forEach((button) => {
          this.bindQuickAddButtonMouseEnter(button);
        });

        if ('MutationObserver' in window) {
          this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              // Add event listener to new buttons
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-swatch-req-drawer').forEach((button) => {
                    this.bindQuickAddButtonMouseEnter(button);
                  });
                }
              });

              // Remove event listener from removed buttons
              mutation.removedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-swatch-req-drawer').forEach((button) => {
                    button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
                  });
                }
              });
            });
          });

          // Start observing changes to the DOM
          this.observer.observe(document.body, { childList: true, subtree: true });
        }
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
      document.querySelectorAll('.js-swatch-req-drawer').forEach((button) => {
        button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      });
      if (this.observer) this.observer.disconnect();
    }

    /**
     * Bind a mouseenter event to a given quick add button if it's not already bound
     * @param {Element} button - The button element to bind the mouseenter event to.
     */
    bindQuickAddButtonMouseEnter(button) {
      if (!button.dataset.quickAddListenerAdded) {
        button.dataset.quickAddListenerAdded = 'true';
        button.addEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      }
    }

    /**
     * Start the fetch on hover of a quick add button for perceived performance gains
     * @param {object} evt - Event object.
     */
    handleQuickAddButtonMouseEnter(evt) {
      if (!this.fetchedUrls.includes(evt.target.dataset.productUrl)) {
        this.fetch = {
          url: evt.target.dataset.productUrl,
          promise: fetch(evt.target.dataset.productUrl)
        };
        this.fetchedUrls.push(evt.target.dataset.productUrl);
      }
    }

    /**
     * Handles 'click' events on success notification's 'View cart' link
     * @param {object} evt - Event object.
     */
    handleOpenCartClick(evt) {
      // Open the cart drawer if available on the page
      if (this.cartDrawer) {
        evt.preventDefault();
        this.cartDrawer.open();
      } else if (window.location.pathname === theme.routes.cart) {
        evt.preventDefault();
        this.close();
      }
    }

    /**
     * Handles 'click' events on the document.
     * @param {object} evt - Event object.
     */
    handleDocumentClick(evt) {
      if (!evt.target.matches('.js-swatch-req-drawer')) return;

      // Close the cart drawer if it's open
      if (this.cartDrawer && this.cartDrawer.ariaHidden === 'false') {
        const overlay = document.querySelector('.js-overlay.is-visible');
        if (overlay) overlay.style.transitionDelay = '200ms';

        this.cartDrawer.close();

        // Wait a few ms for a more optimal ux/animation
        setTimeout(() => {
          this.backBtn.hidden = false;
          this.open(evt.target);
          if (overlay) overlay.style.transitionDelay = '';
        }, 200);
      } else {
        this.open(evt.target);
      }
    }

  
  

    /**
     * Opens the drawer and fetches the product details.
     * @param {Element} opener - Element that triggered opening of the drawer.
     */
    async open(opener) {
      opener.setAttribute('aria-disabled', 'true');

      if (this.notification) this.notification.hidden = true;

      // If it's the same product as previously shown, there's no need to re-fetch the details.
      if (this.productUrl && this.productUrl === opener.dataset.productUrl) {
        super.open(opener);
        opener.removeAttribute('aria-disabled');
        return;
      }

      this.productUrl = opener.dataset.productUrl;
      // this.content.innerHTML = '';
      this.classList.add('is-loading');
      this.content.classList.add('drawer__content--out');
      this.footer.classList.add('drawer__footer--out');

      super.open(opener);

      if (!this.fetch || this.fetch.url !== opener.dataset.productUrl) {
        this.fetch = {
          url: opener.dataset.productUrl,
          promise: fetch(opener.dataset.productUrl)
        };
      }

      const response = await this.fetch.promise;
      if (response.ok) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();
        this.productEl = tmpl.content.querySelector('.cc-main-product .js-product');
        this.renderProduct(opener);
      }

      this.fetch = null;

      opener.removeAttribute('aria-disabled');
    }

    /**
     * Closes the cart drawer.
     */
    close() {
      super.close(() => {
        this.backBtn.hidden = true;
      });
    }


    /**
     * Renders the product details.
     * @param {Element} opener - Element that triggered opening of the drawer.
     */
    renderProduct(opener) {

      // Re-init swatch selection JS
      this.initSwatchLogic();

      // Animate footer/content back in
      this.classList.remove('is-loading');
      this.content.classList.remove('drawer__content--out');
      this.footer.classList.remove('drawer__footer--out');
    }

    initSwatchLogic() {
      const drawer = this;
      const checkboxes = this.querySelectorAll('.swatch-checkbox');
      const countEl = this.querySelector('.swatch-count');
      const addBtn = this.querySelector('.swatch-add-btn');

      if (!checkboxes.length || !countEl || !addBtn) return;

      function updateCount() {
        const selected = drawer.querySelectorAll('.swatch-checkbox:checked').length;
        countEl.textContent = `Selected Swatches (${selected})`;

        if (selected > 0) {
          addBtn.disabled = false;
          addBtn.classList.remove('opacity-50', 'cursor-not-allowed');
        } else {
          addBtn.disabled = true;
          addBtn.classList.add('opacity-50', 'cursor-not-allowed');
        }
      }

      checkboxes.forEach(cb => cb.addEventListener('change', updateCount));


      addBtn.addEventListener('click', async () => {
        const selected = Array.from(drawer.querySelectorAll('.swatch-checkbox:checked'))
          .map(cb => cb.value);

        if (selected.length === 0) {
          showNotify("Please select at least one swatch.", "error");
          return;
        }

        // Disable button while processing
        addBtn.disabled = true;
        addBtn.classList.add('loading');

        try {
          // Fetch current cart to check existing items
          const cart = await fetch('/cart.js').then(res => res.json());
          const cartVariantIds = cart.items.map(item => String(item.variant_id));

          // Filter out already-in-cart variants
          const toAdd = selected.filter(id => !cartVariantIds.includes(id));

          if (!toAdd.length) {
            showNotify("All selected swatches are already in your cart.", "info");
          } else {
            // Add only new swatches
            for (const variantId of toAdd) {
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: 1 })
              });
            }

            // Refresh + open Shopify cart drawer
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));

            // ✅ Reset checkboxes
            drawer.querySelectorAll('.swatch-checkbox:checked').forEach(cb => {
              cb.checked = false;
              cb.closest('label')?.classList.remove('checked');
            });

            // ✅ Reset count text
            if (countEl) countEl.textContent = `Selected Swatches (0)`;

            showNotify("Selected swatches added to cart.", "success");
          }
        } catch (error) {
          console.error('Add to cart error:', error);
          showNotify("Something went wrong while adding swatches to cart.", "error");
        } finally {
          // Re-enable button
          addBtn.disabled = false;
          addBtn.classList.remove('loading');
        }
      });

      // 🔹 Simple notify helper
      function showNotify(message, type = "info") {
        let notif = drawer.querySelector('.swatch-notify');
        if (!notif) {
          notif = document.createElement('div');
          notif.className = 'swatch-notify';
          drawer.querySelector('.swatch-request')?.prepend(notif);
        }

        notif.textContent = message;
        notif.className = `swatch-notify ${type}`;
        notif.hidden = false;

        setTimeout(() => notif.hidden = true, 3000);
      }

      updateCount();
    }




  }

  customElements.define('swatch-request-drawer', SwatchRequestDrawer);
}



